module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MainMenu__main-container"
  }, [_c('div', {
    staticClass: "MainMenu__header"
  }, [_c('div', {
    staticClass: "MainMenu__header-main"
  }, [_c('div', {
    staticClass: "MainMenu__header-container"
  }, [_c('div', {
    staticClass: "MainMenu__header-inner-container"
  }, [_c('img', {
    staticClass: "MainMenu__logo",
    attrs: {
      "src": require("../../../static/images/logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "MainMenu__nav-container"
  }, [_c('div', {
    staticClass: "MainMenu__nav"
  }, [_c('router-link', {
    staticClass: "MainMenu__nav-item",
    class: {
      'active': _vm.$route.name === 'MainMenu' || _vm.$route.name === 'BroadcastingTab'
    },
    attrs: {
      "to": {
        name: 'home-tab'
      }
    }
  }, [_c('i', {
    staticClass: "icon-ic_call"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "MainMenu__nav-item",
    class: {
      'active': _vm.$route.name === 'HistoryTab'
    },
    attrs: {
      "to": {
        name: 'HistoryTab'
      }
    }
  }, [_c('i', {
    staticClass: "icon-ic_history"
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "MainMenu__nav-item",
    class: {
      'active': _vm.$route.name === 'SettingsTab'
    },
    attrs: {
      "to": {
        name: 'SettingsTab'
      }
    }
  }, [_c('i', {
    staticClass: "icon-ic_settings"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "MainMenu__profile"
  }, [_c('div', {
    staticClass: "MainMenu__profile-name"
  }, [_vm._v("\n                " + _vm._s(_vm.user.name) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "MainMenu__profile-avatar-container",
    on: {
      "click": _vm.toggleMainMenu
    }
  }, [_c('img', {
    directives: [{
      name: "fallback-src",
      rawName: "v-fallback-src",
      value: ('../../../static/images/default-user-avatar.jpg'),
      expression: "'../../../static/images/default-user-avatar.jpg'"
    }],
    staticClass: "MainMenu__profile-avatar",
    attrs: {
      "src": _vm.userInfo.avatarUrl
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-ic_star MainMenu__profile-status-icon",
    class: {
      'pro': _vm.subscription.active
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "scale-vertically"
    }
  }, [(_vm.showMainMenu) ? _c('div', {
    directives: [{
      name: "on-click-outside",
      rawName: "v-on-click-outside",
      value: (_vm.hideMainMenu),
      expression: "hideMainMenu"
    }],
    staticClass: "MainMenu__nav-menu"
  }, [_c('div', {
    staticClass: "MainMenu__nav-menu-action logout",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("\n                    logout\n                  ")])]) : _vm._e()])], 1)])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "MainMenu__footer"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183f6ead","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-menu/main-menu.vue
// module id = 420
// module chunks = 1